import PropTypes from 'prop-types'

const ParkingInfoSection = ({ title, children }) => {
  return (
    <div className="parking-info__section">
      <div className="parking-info__section-title">{title}</div>
      {children}
    </div>
  )
}

ParkingInfoSection.propTypes = {
  title: PropTypes.string,
  children: PropTypes.object,
}

export default ParkingInfoSection
